/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaginatedPerformerListList,
  PatchedPerformer,
  Performer,
} from '../models/index';
import {
    PaginatedPerformerListListFromJSON,
    PaginatedPerformerListListToJSON,
    PatchedPerformerFromJSON,
    PatchedPerformerToJSON,
    PerformerFromJSON,
    PerformerToJSON,
} from '../models/index';

export interface PerformersCheckDuplicateRequest {
    id: string;
}

export interface PerformersCreateRequest {
    performer: Omit<Performer, 'id'|'has_bio'|'has_technical_rider'|'has_hospitality_rider'|'has_media'|'profile_completion'|'booking_count'|'created_by_name'|'media'|'created_at'|'updated_at'>;
}

export interface PerformersDestroyRequest {
    id: string;
}

export interface PerformersListRequest {
    directory?: boolean;
    ordering?: string;
    page?: number;
    search?: string;
}

export interface PerformersPartialUpdateRequest {
    id: string;
    patchedPerformer?: Omit<PatchedPerformer, 'id'|'has_bio'|'has_technical_rider'|'has_hospitality_rider'|'has_media'|'profile_completion'|'booking_count'|'created_by_name'|'media'|'created_at'|'updated_at'>;
}

export interface PerformersRetrieveRequest {
    id: string;
}

export interface PerformersStatsRequest {
    id: string;
}

export interface PerformersUpdateRequest {
    id: string;
    performer: Omit<Performer, 'id'|'has_bio'|'has_technical_rider'|'has_hospitality_rider'|'has_media'|'profile_completion'|'booking_count'|'created_by_name'|'media'|'created_at'|'updated_at'>;
}

/**
 * 
 */
export class PerformersApi extends runtime.BaseAPI {

    /**
     * Get performers grouped by category.
     */
    async performersByCategoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Performer>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/by_category/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformerFromJSON(jsonValue));
    }

    /**
     * Get performers grouped by category.
     */
    async performersByCategory(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Performer> {
        const response = await this.performersByCategoryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Check if a performer name already exists.
     */
    async performersCheckDuplicateRaw(requestParameters: PerformersCheckDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Performer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling performersCheckDuplicate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/{id}/check_duplicate/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformerFromJSON(jsonValue));
    }

    /**
     * Check if a performer name already exists.
     */
    async performersCheckDuplicate(requestParameters: PerformersCheckDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Performer> {
        const response = await this.performersCheckDuplicateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersCreateRaw(requestParameters: PerformersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Performer>> {
        if (requestParameters['performer'] == null) {
            throw new runtime.RequiredError(
                'performer',
                'Required parameter "performer" was null or undefined when calling performersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PerformerToJSON(requestParameters['performer']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformerFromJSON(jsonValue));
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersCreate(requestParameters: PerformersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Performer> {
        const response = await this.performersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersDestroyRaw(requestParameters: PerformersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling performersDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersDestroy(requestParameters: PerformersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.performersDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersListRaw(requestParameters: PerformersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPerformerListList>> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['directory'] != null) {
            queryParameters['directory'] = requestParameters['directory'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPerformerListListFromJSON(jsonValue));
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersList(requestParameters: PerformersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPerformerListList> {
        const response = await this.performersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersPartialUpdateRaw(requestParameters: PerformersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Performer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling performersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPerformerToJSON(requestParameters['patchedPerformer']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformerFromJSON(jsonValue));
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersPartialUpdate(requestParameters: PerformersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Performer> {
        const response = await this.performersPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersRetrieveRaw(requestParameters: PerformersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Performer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling performersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformerFromJSON(jsonValue));
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersRetrieve(requestParameters: PerformersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Performer> {
        const response = await this.performersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enhanced search endpoint with duplicate prevention.
     */
    async performersSearchRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Performer>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/search/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformerFromJSON(jsonValue));
    }

    /**
     * Enhanced search endpoint with duplicate prevention.
     */
    async performersSearch(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Performer> {
        const response = await this.performersSearchRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get statistics for a performer.
     */
    async performersStatsRaw(requestParameters: PerformersStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Performer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling performersStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/{id}/stats/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformerFromJSON(jsonValue));
    }

    /**
     * Get statistics for a performer.
     */
    async performersStats(requestParameters: PerformersStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Performer> {
        const response = await this.performersStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersUpdateRaw(requestParameters: PerformersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Performer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling performersUpdate().'
            );
        }

        if (requestParameters['performer'] == null) {
            throw new runtime.RequiredError(
                'performer',
                'Required parameter "performer" was null or undefined when calling performersUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/performers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PerformerToJSON(requestParameters['performer']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PerformerFromJSON(jsonValue));
    }

    /**
     * ViewSet for Performer CRUD operations. Performers are global entities accessible to all authenticated users.
     */
    async performersUpdate(requestParameters: PerformersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Performer> {
        const response = await this.performersUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
